import { generateActions } from "utils/generateActions";

export const GET_TABLE_CATEGORIES = generateActions("GET_TABLE_CATEGORIES");